import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiError } from './api-error';
import { CorrelationService } from './correlation.service';
import { DataSyncService } from './data-sync/data-sync.service';
import { API_URL, ENDPOINT_NAMES_TO_LOG } from '../shared/utils/globals';
import { PreviewTokenService } from './portal-url.service/preview-token.service';
import { previewHeaders } from './portal-url.service/share-link-request';

@Injectable()
export class HttpInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private correlationService: CorrelationService,
    private dataSyncService: DataSyncService,
    private previewTokens: PreviewTokenService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const correlationId = this.correlationService.get();
    const connectionId = this.dataSyncService.connectionId;
    this.logDetails(req.url, correlationId);

    const headers: Record<string, string> = previewHeaders(req.url, API_URL, this.previewTokens.token);
    if (correlationId) headers['X-Correlation-Id'] = correlationId;
    if (connectionId) headers['X-SignalR-Connection-Id'] = connectionId;
    const outgoing = Object.keys(headers).length > 0 ? req.clone({ setHeaders: headers }) : req;

    return next.handle(outgoing).pipe(
      catchError((error: HttpErrorResponse) => {
        const body = error.error;
        const serverMessage = typeof body?.Response === 'string' ? body.Response : null;
        const code = typeof body?.Code === 'string' ? body.Code : null;
        const detail = serverMessage ?? (body instanceof ErrorEvent ? body.message : body?.Error) ?? 'Unknown';
        const reason = code ? `${code}: ${detail}` : detail;
        return throwError(() => new ApiError(
          `Error Code: ${error.status}, Message: ${error.message}, Possible Reason: ${reason}`, error.status, serverMessage));
      })
    );
  }

  private logDetails(url: string, correlationId: string | null): void {

    if (!url || !correlationId) {
      return;
    }

    ENDPOINT_NAMES_TO_LOG.forEach(endpointName => {
      if (url.includes(endpointName)) {
        console.log(`Calling Endpoint '${endpointName}' with correlation Id: ${correlationId}`);
      }
    })
  }
}